import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 flex items-center justify-center px-4">
        <div className="text-center max-w-lg py-20">
          <p className="font-heading text-7xl md:text-9xl font-bold text-primary-500/40 select-none">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">页面走丢了</h1>
          <p className="mt-3 text-sm text-foreground-500">
            你访问的页面可能已被移除、更名，或链接输入有误。不妨回到首页继续探索精彩影视内容。
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <a
              href="/"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" aria-hidden="true" />
              返回首页
            </a>
            <a
              href="/category/movie"
              className="inline-flex items-center gap-2 rounded-md border border-foreground-400/40 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览电影频道
            </a>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}